import { render, staticRenderFns } from "./mahjongLegacy.vue?vue&type=template&id=2fa03bf0&scoped=true"
import script from "./mahjongLegacy.vue?vue&type=script&lang=js"
export * from "./mahjongLegacy.vue?vue&type=script&lang=js"
import style0 from "./mahjongLegacy.vue?vue&type=style&index=0&id=2fa03bf0&prod&scoped=true&lang=css"
import style1 from "./mahjongLegacy.vue?vue&type=style&index=1&id=2fa03bf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa03bf0",
  null
  
)

export default component.exports